export default __webpack_public_path__ + "static/media/demo3.9342a606.gif";